import { t } from "../../../hooks/useAppTranslation";
import {useEffect, useState} from 'react';

import {removeDocument} from '../../../Properties/Properties';
import {getServicePromise} from '../../HttpService/HttpService';


export const RemoveDocument = ({
                                 controlUuid,
                                 documentId,
                                 documentName,
                                 onRemove
                               }) => {
  const [removingOn, setRemovingOn] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    if (!removingOn) { return }
    setFetchError(null);

    const callPromise = getServicePromise(
      removeDocument(documentId, controlUuid), 'DELETE');
    callPromise.then(
      function () {
        onRemove(documentId);
      },
      function (error) {
        setFetchError(error);
        setRemovingOn(false);
      }
    );
  }, [removingOn]);

  return (
    <div className="documents__remove-container">
      <button
          className="btn delete-btn"
          disabled={removingOn}
          onClick={() => setRemovingOn(true)}
      >
        {removingOn ? t('g-deleting') : t('g-delete')}
        <span className="sr-only">{removingOn ? t('g-file-2') : t('g-file-1')} {documentName}</span>
      </button>
      {fetchError && <p className="error-text documents__remove-error">{fetchError}</p>}
    </div>
  )
};
